import React from "react";
import { useMatch } from "react-router";

import {
  LoginPage,
  LoginPagePropsForNewUser,
} from "../components/login/LoginPage";
import { MagicLinkSentView } from "../components/signup/MagicLinkSentView";

import { LoginListener } from "./LoginListener";
import { Routes, useUrlFragment } from "./routes";

export const MagicLinkSentRoute: React.ComponentType = React.memo(
  function MagicLinkSentRoute() {
    const signupRouteMatch = useMatch(Routes.SIGNUP.path);
    const fragment = useUrlFragment();
    const email = fragment.email ?? "";

    return (
      <LoginPage
        embedded={true}
        {...(signupRouteMatch ? LoginPagePropsForNewUser : {})}
      >
        <LoginListener />
        <MagicLinkSentView email={email} />
      </LoginPage>
    );
  },
);
